'use strict';

document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
  const menu = document.getElementById(button.getAttribute('aria-controls'));
  if (!menu) return;

  const mobile = window.matchMedia('(max-width: 760px)');
  const syncMenu = () => {
    const open = button.getAttribute('aria-expanded') === 'true';
    menu.hidden = mobile.matches && !open;
  };

  button.addEventListener('click', () => {
    const open = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!open));
    syncMenu();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || button.getAttribute('aria-expanded') !== 'true') return;
    button.setAttribute('aria-expanded', 'false');
    syncMenu();
    button.focus();
  });

  mobile.addEventListener('change', syncMenu);
  syncMenu();
});
